export type SamplePhaseStatus = "complete" | "in-progress" | "not-started";

export function getSamplePhaseStatus(
  phaseIndex: number,
  phaseCount: number,
): SamplePhaseStatus {
  const activeIndex = Math.max(0, phaseCount - 2);
  if (phaseIndex < activeIndex) return "complete";
  if (phaseIndex === activeIndex) return "in-progress";
  return "not-started";
}

export function getSampleActionStatus(
  phaseStatus: SamplePhaseStatus,
  actionIndex: number,
  actionCount: number,
): "Complete" | "In progress" | "Incomplete" {
  if (phaseStatus === "complete") return "Complete";
  if (phaseStatus === "not-started") return "Incomplete";

  const completedCount =
    actionCount === 1 ? 0 : Math.max(1, Math.floor(actionCount / 2));
  if (actionIndex < completedCount) return "Complete";
  if (actionIndex === completedCount) return "In progress";
  return "Incomplete";
}
